import React, { useEffect } from "react";
import {
  AdyenCheckout,
  Dropin,
  Card,
  Redirect,
  GooglePay,
  PayPal,
  ApplePay,
} from "@adyen/adyen-web/auto";
import "@adyen/adyen-web/styles/adyen.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function AdyenDropin() {
  const dispatch = useDispatch();
  // get session object from redux
  const adyenSessionData = useSelector(
    (state: any) => state.SettingSlice.adyenSession,
  );
  const orderNumberForRedirect = useSelector(
    (state: any) => state.SettingSlice.orderNumberForRedirect,
  );

  useEffect(() => {
    getAdyenPage();
  }, [dispatch]);

  async function getAdyenPage() {
    const globalConfiguration: any = {
      session: {
        id: adyenSessionData.id, // Unique identifier for the payment session.
        sessionData: adyenSessionData.sessionData, // The payment session data.
      },
      environment: process.env.REACT_APP_ADYEN_ENV, // Change to 'live' for the live environment.
      amount: {
        value: 1000,
        currency: "EUR",
      },
      locale: adyenSessionData.shopperLocale,
      countryCode: "DE",
      clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
      onPaymentCompleted: (result: any, component: any) => {
        if (result.resultCode === "Authorised" && orderNumberForRedirect) {
          window.location.replace(
            `/#/payment-success?order=${orderNumberForRedirect}`,
          );
        } else {
          window.location.replace(
            `/#/payment-cancel?order=${orderNumberForRedirect}`,
          );
        }
      },
      onPaymentFailed: (result: any, component: any) => {
        if (result.resultCode) {
          window.location.replace(
            `/#/payment-cancel?order=${orderNumberForRedirect}`,
          );
        }
      },
      onError: (error: any, component: any) => {
        console.error(error.name, error.message, error.stack, component);
      },
    };

    // All of the resources that you imported are properties of the window.
    // In this example you imported Card, GooglePay, and Paypal individually.
    // const { AdyenCheckout, Dropin, Card, GooglePay, PayPal  } = window.AdyenWeb
    const checkout = await AdyenCheckout(globalConfiguration);

    const dropinConfiguration: any = {
      // Other Drop-in configuration...
      paymentMethodComponents: [Card, Redirect, PayPal, GooglePay, ApplePay],
      // Optional configuration.
      onReady: () => {},
      // instantPaymentTypes: ["applepay", "googlepay"],
      paymentMethodsConfiguration: {
        card: {
          // Optional configuration.
          hasHolderName: true, // Show the cardholder name field.
          holderNameRequired: true, // Mark the cardholder name field as required.
        },
      },
    };

    // const dropin = new Dropin(checkout, dropinConfiguration).mount('#dropin');
    new Dropin(checkout, dropinConfiguration).mount("#dropin-container");
  }

  return (
    <div
      id="dropin-container"
      // style={{ maxWidth: 500, margin: "50px auto" }}
    ></div>
  );
}
